import React from 'react';
import { Group, Text } from '@mantine/core';
import { parseTags, formatTagsForDisplay, getTagColor } from '../utils/tagUtils';

interface TagDisplayProps {
  tags?: string[] | string;
  onTagClick?: () => void;
  maxVisible?: number;
  size?: 'xs' | 'sm' | 'md';
}

export const TagDisplay: React.FC<TagDisplayProps> = ({ 
  tags, 
  onTagClick, 
  maxVisible = 5,
  size = 'xs'
}) => {
  const parsedTags = formatTagsForDisplay(parseTags(tags));
  
  if (parsedTags.length === 0) {
    return null;
  }

  const visibleTags = parsedTags.slice(0, maxVisible);
  const hiddenCount = parsedTags.length - maxVisible;

  return (
    <Group gap={4} wrap="nowrap">
      {visibleTags.map((tag, index) => (
        <Text
          key={`${tag}-${index}`}
          size={size}
          onClick={onTagClick}
          style={{ 
            borderBottom: `2px solid var(--mantine-color-${getTagColor(tag)}-4)`,
            paddingBottom: '1px',
            cursor: onTagClick ? 'pointer' : 'default',
            userSelect: 'none',
            transition: 'all 0.2s ease',
            lineHeight: 1.2,
            color: `var(--mantine-color-${getTagColor(tag)}-4)`, // Use lighter shade for better contrast in dark mode
          }}
          styles={{
            root: onTagClick ? {
              '&:hover': {
                borderBottomColor: `var(--mantine-color-${getTagColor(tag)}-5)`,
                color: `var(--mantine-color-${getTagColor(tag)}-5) !important`,
                transform: 'translateY(-1px)',
              }
            } : undefined
          }}
        >
          {tag}
        </Text>
      ))}
      {hiddenCount > 0 && (
        <Text
          size={size}
          c="dimmed"
          onClick={onTagClick}
          style={{ 
            cursor: onTagClick ? 'pointer' : 'default',
            fontStyle: 'italic'
          }}
        >
          +{hiddenCount} more
        </Text>
      )}
    </Group>
  );
};